let DEFAULT_NAMES = {
  region: ["North Central", "North West", "UPUK", "East", "North East", "West MAH", "SOUTH AK", "South 3C", "SHQ", "NA", "Total"],
  area: ["Ahmedabad", "Andhra Pradesh", "Arunachal Pradesh", "Bangalore", "Bhubaneshwar", "Bihar", "Chandigarh", "Chennai", "Cochin", "Coimbatore", "Total"],
  client_facility_code: ["AMDFC1", "AMDFC2", "BLRFC6", "MAAFC2", "COKFC3", "CJBFC1", "GGNFC6", "DELFC6", "DELFC7", "GZEFC1", "Total"]
}

let DEFAULT_STATUS_DATA = {
  "total": 12926,
  "delivered": 2324,
  "in_transit": 4126,
  "BBDN": 2001,
  "to_be_invoiced": 4479
}

function getData(code) {
  let array = [];
  for (var i=0; i<11; i++) {
    array.push({...{[code]: DEFAULT_NAMES[code][i]}, ...DEFAULT_STATUS_DATA});
  }
  return array;
}

export const data = {
  region: getData('region'),
  area: getData('area'),
  warehouse: getData('client_facility_code')
}

export const columns = ['Region', 'Total Ordered', 'Delivered', 'InTransit', 'BBND', 'To be invoiced'];
